import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-58" data-mp="2hukss24eivsx">
      <div className="max-w-4xl mx-auto" data-id="element-59" data-mp="2hw45jiqumopy">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 text-[12px] font-[600] font-[Figtree,_sans-serif]" data-id="element-60" data-mp="23vl26oxbw6u4">
          "Recursos visuales y adaptados para alumnos neurodivergentes y
          distintos ritmos de aprendizaje"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-61" data-mp="2wkikut5gc5ne">
          <span className="px-2 text-[#F9327E] bg-[#FFFFFF] text-[24px]" data-id="element-62" data-mp="30ksrm812j03b">
            MEGAPACK INCLUSIÓN EDUCATIVA
          </span>
        </h1>

        <h2 className="md:text-2xl font-extrabold mb-3 text-gray-800 text-[16px]" data-id="element-63" data-mp="2rsqscd2qjpum">
          Material diseñado especialmente para docentes que trabajan inclusión
          educativa real y necesitan recursos más claros, accesibles y posibles
          para distintos perfiles de aprendizaje.
        </h2>

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-64" data-mp="2ff8u4tarc6vf">
          <img src="https://cdn.magicpatterns.com/uploads/6StH4fvB71N27f4GFRSpio/mockup_pincipal.png" alt="Megapack Inclusión Educativa" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-65" data-mp="2ffs5ts9tdz10" />
        </div>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-66" data-mp="2kdk3l2x54fd4">
          <p className="text-[14px]" data-id="element-67" data-mp="2z26ix4mrp74c">
            Actividades listas para imprimir y usar en el aula.
          </p>
        </div>

        <div className="flex flex-nowrap items-center justify-center gap-2 md:gap-3 mb-4" data-id="element-68" data-mp="2u6ivouruio1h">
          <span className="text-base md:text-2xl font-bold text-gray-400 line-through whitespace-nowrap" data-id="element-69" data-mp="383ef9h5q3xvs">
            ARS $39.990
          </span>
          <span className="bg-red-600 text-white text-[11px] md:text-sm font-black px-2.5 md:px-3 py-1 rounded-full whitespace-nowrap" data-id="element-70" data-mp="1dpn0k38jenth">
            50% OFF
          </span>
          <span className="text-2xl md:text-4xl font-black text-[#1e3a8a] whitespace-nowrap" style={{
          color: "#F9327E"
        }} data-id="element-71" data-mp="18tg02pywu4ix">
            $19.990
          </span>
        </div>

        <div className="bg-blue-50 rounded-2xl p-5 max-w-md mx-auto border border-blue-100" data-id="element-72" data-mp="3dso7p64pww4t">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-73" data-mp="3ipxv6g8jqxq0">
            👉 Beneficios del material
          </p>
          <div className="space-y-2 text-left" data-id="element-74" data-mp="3mqzuex2gr9rz">
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-75" data-mp="3rsyxs6y7e6ox">
              <span className="text-green-600 mr-2 text-lg" data-id="element-76" data-mp="lcnhvgzb5z3">✔️</span> Menor
              sobrecarga visual
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-77" data-mp="5dnpr4z6z3ut">
              <span className="text-green-600 mr-2 text-lg" data-id="element-78" data-mp="abyy1b9u96ax">✔️</span>{' '}
              Actividades simples y graduales
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-79" data-mp="eevmvjpz1ynb">
              <span className="text-green-600 mr-2 text-lg" data-id="element-80" data-mp="jd5h9s3vgv7v">✔️</span> Diseño
              accesible y recursos multinivel
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-81" data-mp="23s1ww94yw60j">
              <span className="text-green-600 mr-2 text-lg" data-id="element-82" data-mp="1yu0elqfd8aq4">✔️</span> Más
              participación y comprensión
            </p>
          </div>
        </div>
      </div>
    </section>;
}